import React, { useState, useEffect } from "react";
import { Menu, X, GraduationCap } from "lucide-react";
import { WHATSAPP_LINK } from "../../data/programs";

const NAV_LINKS = [
  { href: "#programs", label: "Programs" },
  { href: "#fees", label: "Fees" },
  { href: "#how-it-works", label: "How it works" },
  { href: "#faq", label: "FAQ" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      data-testid="navbar"
      className={[
        "sticky top-0 z-40 transition-all duration-300",
        scrolled
          ? "bg-aiou-paper/85 backdrop-blur-md border-b border-aiou-sand shadow-[0_4px_24px_rgba(36,66,101,0.05)]"
          : "bg-transparent",
      ].join(" ")}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 flex h-16 items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-brand"
          className="flex items-center gap-2.5 min-w-0"
          onClick={close}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white border border-aiou-sand shadow-sm overflow-hidden">
            <img
              src="/aiou-logo.png"
              alt="AIOU"
              className="h-8 w-8 object-contain"
            />
          </span>
          <span className="font-serif text-lg sm:text-xl text-aiou-ink leading-tight">
            AIOU <span className="text-aiou-steel">International</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="px-3 py-2 text-sm text-aiou-slate hover:text-aiou-steel transition-colors rounded-full hover:bg-aiou-sand/40"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={WHATSAPP_LINK()}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-cta"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-aiou-steel text-white px-4 py-2 text-sm font-medium shadow-md shadow-aiou-steel/20 hover:bg-aiou-steelDark transition-all"
          >
            <GraduationCap className="h-4 w-4" strokeWidth={1.7} />
            Free Guidance
          </a>
          <button
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
            data-testid="navbar-toggle"
            className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-aiou-sand bg-white text-aiou-slate"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-aiou-sand bg-aiou-paper/95 backdrop-blur-md">
          <div className="mx-auto max-w-7xl px-5 py-3 flex flex-col">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={close}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="py-3 text-sm text-aiou-ink border-b border-aiou-sand/60 last:border-b-0"
              >
                {l.label}
              </a>
            ))}
            <a
              href={WHATSAPP_LINK()}
              target="_blank"
              rel="noreferrer"
              onClick={close}
              className="mt-3 mb-1 inline-flex justify-center rounded-full bg-aiou-steel text-white px-4 py-2.5 text-sm font-medium"
            >
              Get Free Guidance
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
